export const CurrencyIdSymbol = 'Exodus:CurrencyId';
export const UnitTypeIdSymbol = 'Exodus:UnitTypeId';
